export const i18n_en = {
  nav: {
    ressources: "Ressources",
    mv_tiles: "MV Exclusiv",
    engine_free: "Engine Free",
    games: "Games",
    halloween: "Halloween im Hexenhaus",
    au_schwarte: "Au Schwarte!",
    hans_dampf: "Hans Dampf Maschine",
    cthulhu: "Cthulhu Clicker",
    nachtschatten: "Nachtschatten",
    bloxxs: "Bloxxs",
    kontakt: "Contact",
    apps: "Apps",
    draw_it: "Draw It!",
    dreaming_fox: "Dreaming Fox",
  },
  mv: {
    heading: "<- Choose a package",
    download: "Download Package",
    licence_mv: `
    <h2>License </h2></br>
    These ressources are edits of the MV-RTP, so you have to own the RPG Maker MV if you want to use them.
    The ressources may only be used in the RPG Maker program! 
    <ul>
      <li> Free to use for non commercial games. I want a finished version of your game -> if you use the ressources for commercial projects i want a finished version of your game </li>
      <li> Credits goes to Kadokawa/Enterbrain, to me (NuraRay) and other artists who are involved in some cowork-sets.</li>

      <li> Edits for own purposes are free allowed. </li>
      <li> No reposts of my tilesets or resulting edits!</li>
      </ul>
      `,
    licence_free: `
    <h2>License </h2></br>
    These ressources made by me, so you can use them in any engine you want. They are optimized fpr RPG Maker MV.
    <ul>
      <li> Free to use for non commercial games. </li>
      <li> for commercial use, you have to buy a licence. </li>
      <li> Everyone who purchased a licence gets access to all future tree-tiles! I´ve planned additional trees, variations, season-editions and so on. You can also go for a wish ;)</li>
      <li> The licence and access to all upcoming tiles you can get on the MakerMole Website: https://makermoles.jimdo.com/en/engine-independ-ressources/</li>

      <li> Credits goes to me (NuraRay) </li>

      <li> Edits for own purposes are free allowed. </li>
      <li> No reposts of my tilesets or resulting edits!</li>
    </ul>
      `,
  },
  lang_de: "german",
  lang_en: "english",
  game: {
    release: "Release",
    engine: "Engine",
    platform: "Platform",
    genre: "Genre",
    playtime: "Playtime",
    language: "Language",
    descr: "Description",
    web: "Links and Let's Plays",
  },
  app: {
    download: "Get the App!",
  },
  contact: {
    social: "Visit me on Social Media!",
    subtext: `Hey, I'm glad you're here. Nice to see that you are interested in my content, 
    that is cool! There is more stuff created by me on the internet here are the most important links!
    <br /><br />
    <strong>You want to see more from me?</strong> -> Then check out my Instagram profile or follow me on Twitter.<br />
    <strong>You have a question or a request?</strong>  -> 
    Contact me via e-mail or another channel!`,
    insta: ` <h3>Instagram</h3>
    More pixelart from me! Custom Tilesets, custom avatars and other game assets. That's my portfolio!`,
    mail: ` <h3>Mail</h3>
    Feel free to write me if you have a question, feedback or a request! I look forward to reading from you!`,
    twitter: `    <h3>Twitter</h3>
    Here are pixelart from me and great pixelartworks from other very talented persons. :)`,
  },
  dashboard: {
    welcome: "Aloha and Welcome!",
    about_txt: `
    Hi! I'm Anne!<br>
    Frontend developer, UX/UI designer and pixelartist. I love the
    Retro style, indigames and relaxed pixelling after a stressful day.<br> 
    Here you can discover my game assets and previous releases. <br>
    Have a good time!  :3
    `,
    explore: "Was willst du zu erst entdecken?",
  },
};
